/**
 * @format
 */

import {
  DELETE_LIST_SUCCESS,
  DELETE_LIST_OPTIMISTIC,
  DELETE_LIST_REVERT,
} from '../actions';

export default (state, type, payload) => {
  switch (type) {
    case DELETE_LIST_OPTIMISTIC: {
      const { workspace_id, listId } = payload;

      const { [listId]: removedList, ...remainingLists } =
        state.lists[workspace_id] || {};

      return {
        ...state,
        lists: {
          ...state.lists,
          [workspace_id]: remainingLists,
        },
        // Optional: mark loading
        listsLoadingMap: {
          ...state.listsLoadingMap,
          [listId]: true,
        },
        listsError: {
          ...state.listsError,
          [listId]: null,
        },
      };
    }

    case DELETE_LIST_SUCCESS: {
      const { listId } = payload;
      const listsLoadingMap = { ...state.listsLoadingMap };
      delete listsLoadingMap[listId];
      return {
        ...state,
        listsLoadingMap,
      };
    }

    case DELETE_LIST_REVERT: {
      const { workspace_id, listId, currentList, message } = payload;

      return {
        ...state,
        lists: {
          ...state.lists,
          [workspace_id]: {
            ...state.lists[workspace_id],
            [listId]: currentList,
          },
        },
        listsLoadingMap: {
          ...state.listsLoadingMap,
          [listId]: false,
        },
        listsError: {
          ...state.listsError,
          [listId]: message,
        },
      };
    }

    default:
  }
};
